import React from 'react';
import { Button, H4, H5, H6 } from '@blueprintjs/core';
import { useQuery } from '@tanstack/react-query';
import TritonAPI from 'AppModules/Triton/API/TritonAPI';
import { useSelector } from 'react-redux';

const SK_utils = (props) => {
  const token = useSelector((store) => store.authReducer.token || '');
  const webFileQuery = useQuery(['webDataFileLink'], () => TritonAPI.getS3PresignedLink(token, 'Web/trafficConversion/default/fullData_combined_SK.csv'));
  const emailFileQuery = useQuery(['emailDataFileLink'], () => TritonAPI.getS3PresignedLink(token, 'Web/Email/fullData.tsv'));
  const mediaSocialFileQuery = useQuery(['mediaSocialDataFileLink'], () => TritonAPI.getS3PresignedLink(token, 'Media/Outputs/Social.csv'));
  const mediaSearchFileQuery = useQuery(['mediaSearchDataFileLink'], () => TritonAPI.getS3PresignedLink(token, 'Media/Outputs/Search.csv'));
  const mediaTVFileQuery = useQuery(['mediaTVDataFileLink'], () => TritonAPI.getS3PresignedLink(token, 'Media/Outputs/TV.csv'));
  const mediaRadioFileQuery = useQuery(['mediaRadioDataFileLink'], () => TritonAPI.getS3PresignedLink(token, 'Media/Outputs/Radio.csv'));

  const a = 1;
  return (
    <div className="SK_utils" style={{ margin: '10px' }}>
      <header>
        <section className="titleRow">
          <H4>SK Utility page</H4>
        </section>
      </header>
      <main style={{ marginTop: '30px' }}>
        <H5 style={{ marginTop: '20px' }}>Web</H5>
        <hr style={{ borderTop: 'solid 1px grey', borderBottom: 'none' }} />
        <div className="mainContent" style={{ display: 'flex', gap: '40px' }}>
          <div style={{ margin: '10px 0' }}>
            <H6>Web Data File</H6>
            <a href={webFileQuery.data} download="fullData_combined.csv">
              <Button large icon="download" intent="primary" loading={webFileQuery.isLoading} disabled={!webFileQuery.data}>
                Download
              </Button>
            </a>
          </div>
          <div style={{ margin: '10px 0' }}>
            <H6>Email Data File</H6>
            <a href={emailFileQuery.data} download="emailData.tsv">
              <Button large icon="download" intent="primary" loading={emailFileQuery.isLoading} disabled={!emailFileQuery.data}>
                Download
              </Button>
            </a>
          </div>
        </div>

        <H5 style={{ marginTop: '20px' }}>Media</H5>
        <hr style={{ borderTop: 'solid 1px grey', borderBottom: 'none' }} />
        <div className="mainContent" style={{ display: 'flex', gap: '40px' }}>
          <div style={{ margin: '10px 0' }}>
            <H6>Media - Social Data File</H6>
            <a href={mediaSocialFileQuery.data} download="Social.csv">
              <Button large icon="download" intent="primary" loading={mediaSocialFileQuery.isLoading} disabled={!mediaSocialFileQuery.data}>
                Download
              </Button>
            </a>
          </div>
          <div style={{ margin: '10px 0' }}>
            <H6>Media - Search Data File</H6>
            <a href={mediaSearchFileQuery.data} download="Search.csv">
              <Button large icon="download" intent="primary" loading={mediaSearchFileQuery.isLoading} disabled={!mediaSearchFileQuery.data}>
                Download
              </Button>
            </a>
          </div>
          <div style={{ margin: '10px 0' }}>
            <H6>Media - TV Data File</H6>
            <a href={mediaTVFileQuery.data} download="TV.csv">
              <Button large icon="download" intent="primary" loading={mediaTVFileQuery.isLoading} disabled={!mediaTVFileQuery.data}>
                Download
              </Button>
            </a>
          </div>
          <div style={{ margin: '10px 0' }}>
            <H6>Media - Radio Data File</H6>
            <a href={mediaRadioFileQuery.data} download="Radio.csv">
              <Button large icon="download" intent="primary" loading={mediaRadioFileQuery.isLoading} disabled={!mediaRadioFileQuery.data}>
                Download
              </Button>
            </a>
          </div>
        </div>
      </main>
    </div>
  );
};

export default SK_utils;
